// ----------------------------------------------------------------------------
// Web Component: iamCartSummary <iam-cart-summary>
// Extends: HTMLElement
// ----------------------------------------------------------------------------
// TODO
// ----------------------------------------------------------------------------
// Customization:
// - TODO
// ----------------------------------------------------------------------------
// Event Listeners:
// - `cart:modified`       → Listens for when the cart is modified
// ----------------------------------------------------------------------------
// Event Triggers:
// - `cartForm:summary:updated`    → Triggers when the cart summary is updated
// ----------------------------------------------------------------------------
// Key Data Mutations:
// - Fetches cart summary data and updates the cart summary section
// ----------------------------------------------------------------------------
// Gotchas:
// - Relies on promises to fetch cart summary data, which may fail if the API calls do not resolve successfully.
// - Error messages are injected into the `.summary__errors-container` element
//   and the summary is marked with a `--error` class until resolved
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_free-shipping-progress.scss';